import React, { useEffect } from 'react'
import logoNav from '../../img/logoNavColor.png'
import '../../css/navbar.css';
import { Link, NavLink } from 'react-router-dom';

const Navbar = ({M, setModalPreLogin}) => {

   useEffect(() => {
      var sidenav = document.querySelectorAll(".sidenav");
      M.Sidenav.init(sidenav);

      var collapsible = document.querySelectorAll(".collapsible");
      M.Collapsible.init(collapsible);
   }, []);

   return (
      <>
         <div className="navbar-fixed">
            <nav className="white">
               <div className="nav-wrapper container">
                     <Link href="/<?=$this->config->item('host')?>home" className="brand-logo"> 
                        <img className="responsive-img" src={logoNav} width="170px"/>
                     </Link>
                     <Link href="/<?=$this->config->item('host')?>home" data-target="menu-responsive" className="sidenav-trigger"><i className="material-icons text-color-latitud">menu</i></Link>
                     <ul id="nav-mobile" className="right hide-on-med-and-down">
                        <li><NavLink className="text-color-latitud navbar-hover" to={"/"}>Inicio</NavLink></li>
                        <li><NavLink className="text-color-latitud navbar-hover" to={"/institucional"}>Institucional</NavLink></li>
                        <li><NavLink className="text-color-latitud navbar-hover" to={"/seguros"}>Seguros</NavLink></li>
                        <li><NavLink className="text-color-latitud navbar-hover" to={"/contacto"}>Contacto</NavLink></li>
                        <li><NavLink className="text-color-latitud navbar-hover" to={"/normativa"}>Normativa</NavLink></li>
                        <li><NavLink className="text-color-latitud navbar-hover" to={"descargas"}>Descargas</NavLink></li>
                        <li><NavLink className="btn-login" onClick={()=>{setModalPreLogin('active')}}>Mi Latitud</NavLink></li>
                        {/* <li><NavLink className="btn-login" target="_blank" to={"art/auth/login"}>Mi Latitud</NavLink></li> */}
                     </ul>
               </div>         
            </nav>
         </div>
         <ul className="sidenav collapsible" id="menu-responsive">
            <li><NavLink to={"/"}><i className="material-icons">home</i>Inicio</NavLink></li>
            <li><div className="divider"></div></li>
            <li><NavLink to={"/institucional"}><i className="material-icons">group_work</i>Institucional</NavLink></li>
            <li><div className="divider"></div></li>
            <li><NavLink to={"/seguros"}><i className="material-icons">security</i>Seguros</NavLink></li>
            <li><div className="divider"></div></li>
            <li><NavLink to={"/contacto"}> <i className="material-icons">contact_mail</i>Contacto</NavLink></li>
            <li><div className="divider"></div></li>
            <li><NavLink to={"/normativa"}> <i className="material-icons">library_books</i>Normativa</NavLink></li>
            <li><div className="divider"></div></li>
            <li><NavLink to={"/descargas"}> <i className="material-icons">cloud_downloa</i>Descargas</NavLink></li>
            <li><div className="divider"></div></li>
            {/* <li><NavLink onClick={()=>{setModalPreLogin('active')}}><i className="material-icons">account_circle</i>Mi Latitud</NavLink></li> */}
            <li>
                  <div class="collapsible-header collapsible-mi-latitud-header">
                     <i className="material-icons mi-latitud">account_circle</i>Mi Latitud
                  </div>
                  <div class="collapsible-body collapsible-mi-latitud-body"><Link target='_blank' className="btn-gestion-sidenav" to={"https://128.1.1.223/app.art/#/ionAuthLogin/login"}>ART</Link></div>
                  <div class="collapsible-body collapsible-mi-latitud-body"><Link className="btn-gestion-sidenav" onClick={""}>GRANIZO</Link></div>
                  <div class="collapsible-body collapsible-mi-latitud-body"><Link className="btn-gestion-sidenav" onClick={""}>AUTOMOTOR</Link></div>
                  <div class="collapsible-body collapsible-mi-latitud-body"><Link className="btn-gestion-sidenav" onClick={""}>SOY PRESTADOR MÉDICO</Link></div>
                  {/* <div class="collapsible-body collapsible-mi-latitud-body"><p>GRANIZO</p></div> */}
            </li>
         </ul>
      </>
   )
}

export default Navbar